<template>
  <div
    class="input-autosave"
    :class="{'d-inline-block': !block, 'd-block': block}"
    @mouseover="hover = true"
    @mouseout="hover = false"
  >
    <template v-if="!editMode">
      <slot
        name="link"
        :edit="edit"
        :hover="hover"
      >
        <a
          href="#"
          :class="{'d-block': block}"
          @click.stop.prevent="edit"
        >
          <slot>
            <font-awesome-icon :icon="icon" />
            {{ label }}
          </slot>
        </a>
      </slot>
    </template>
    <div v-else>
      <input
        ref="input"
        v-model="name"
        type="text"
        class="form-control"
        @keyup.enter="onSubmit"
        @blur="onBlur"
      >
      <div class="text-right">
        <a
          href="#"
          class="text-muted"
          @click.prevent="editMode = false"
        >Cancel</a>
        <span class="mx-2">|</span>
        <a
          href="#"
          @click.prevent="onSubmit"
        >Save</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputAutoSave',
  props: {
    value: {
      type: String,
      default: '',
    },
    block: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: 'plus-circle',
    },
    label: {
      type: String,
      default: 'New Item',
    },
  },
  data() {
    return {
      name: '',
      editMode: false,
      hover: false,
    };
  },
  methods: {
    edit() {
      this.editMode = true;
      this.name = this.value;
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    onBlur() {
      setTimeout(() => {
        this.editMode = false;
      }, 500);
    },
    onSubmit() {
      if (this.name === '') {
        this.editMode = false;
        return;
      }

      this.$emit('submit', this.name);
      this.editMode = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.input-autosave{
    // background-color: red;
}
</style>
